import * as React from 'react';

export interface ICardSectionProps {
  label: string;
  children: React.ReactNode;
}

/**
 * Labeled group inside a settings card: an uppercase section heading above a
 * vertical stack of fields. Shared across the settings forms so every section
 * heading and field gap stays consistent.
 */
const CardSection = ({ label, children }: ICardSectionProps) => (
  <div className="flex flex-col gap-5">
    <p className="text-quaternary text-xs font-semibold uppercase tracking-wide">{label}</p>
    <div className="flex flex-col gap-4">{children}</div>
  </div>
);

CardSection.displayName = 'CardSection';

export default CardSection;
